/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@import url(https://fonts.googleapis.com/css2?family=Muli:ital,wght@0,400;0[_ngcontent-%COMP%], 500[_ngcontent-%COMP%];0[_ngcontent-%COMP%], 700[_ngcontent-%COMP%];1[_ngcontent-%COMP%], 400&display=swap)[_ngcontent-%COMP%];.new-number-link[_ngcontent-%COMP%]{border-right:1px solid rgba(120,130,140,.2);border-left:1px solid rgba(120,130,140,.2);padding:0 20px}.responsive-container[_ngcontent-%COMP%]{width:100%}cc-section[_ngcontent-%COMP%]{grid-row-gap:unset}"];
export { styles as styles };
